import { Layout } from "./layout";

type Props = {
	title: string;
	children: React.ReactNode;
};

export const SectionLayout = ({ title, children }: Props) => {
	return (
		<Layout className="space-y-4">
			<h5 className="font-bold">{title}</h5>

			{children}
		</Layout>
	);
};
